




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';

@Component
export default class SelectedItems extends Vue {
    @Prop() public hideLabel!: string;

    constructor() {
        super();
    }

    get selectedBuildings(): any {
        return this.$store.getters['Buildings/selectedBuildings'];
    }

    get selectedProjects(): any {
        return this.$store.getters['Projects/selectedProjects'];
    }

    get selectedProperties(): any {
        return this.$store.getters['Properties/selectedProperties'];
    }

    public deselectBuilding(itemId: number) {
        this.$store.commit(Mutations.DESELECT_BUILDING, itemId);
        this.$emit('buildingsDeleted');
    }

    public deselectAllBuildings() {
        this.$store.commit(Mutations.RESET_BUILDING_SELECTION);
        this.$emit('buildingsDeleted');
    }

    public deselectProject(itemId: number) {
        this.$store.commit(Mutations.DESELECT_PROJECT, itemId);
    }

    public deselectProperty(itemId: number) {
        this.$store.commit(Mutations.DESELECT_PROPERTY, itemId);
        this.$emit('propertiesDeleted');
    }

    public deselectAllProperties() {
        this.$store.commit(Mutations.RESET_PROPERTY_SELECTION);
        this.$emit('propertiesDeleted');
    }

    public hasSelectedItems() {
        return (this.selectedProjects.length > 0 || this.selectedBuildings.length > 0 || this.selectedProperties.length > 0);
    }
}
